import React from 'react';
import { string, shape } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { Col } from '@thd-olt-component-react/grid';
import requiredStyles from './RequiredAttributes.module.scss';

const RequiredAttributes = ({ metadata }) => (
  <Col>
    <div className={requiredStyles['meta-container']}>
      <div className={requiredStyles.item}>
        <Image src={metadata.difficultyLevelImageURL} alt="difficulty" height="36" width="36" />
        <div>
          <span className={requiredStyles.bold}>Difficulty</span>
          <br />
          <span>{metadata.difficulty}</span>
        </div>
      </div>

      <div className={requiredStyles.item}>
        <Image src={metadata.prjDurationImageURL} alt="duration" height="36" width="36" />
        <div>
          <span className="bold">Time</span>
          <br />
          <span>{metadata.duration}</span>
        </div>
      </div>

      <div className={requiredStyles.item}>
        <Image
          src="https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/Articles/learnhowicon.svg"
          alt="learn how"
          height="36"
          width="36"
        />
        <div>
          <span>
            <a href={metadata.pgurl} className={requiredStyles['learn-how']} target="_blank" rel="noreferrer">
              Learn&nbsp;How
            </a>
          </span>
        </div>
      </div>
    </div>
  </Col>
);

RequiredAttributes.propTypes = {
  metadata: shape({
    difficulty: string,
    difficultyLevelImageURL: string,
    prjDurationImageURL: string,
    pgImageURL: string,
    pgurl: string,
    duration: string,
    messaging: string
  }),
};

RequiredAttributes.defaultProps = {
  metadata: {
    difficulty: '',
    difficultyLevelImageURL: '',
    prjDurationImageURL: '',
    pgImageURL: '',
    pgurl: '',
    duration: '',
    messaging: ''
  }
};

export { RequiredAttributes };
